import { Select } from 'antd';
import styled, { css } from 'styled-components';

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .drawer-header {
    padding: 12px 8px 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      display: flex;
      align-items: center;
    }

    .ant-image {
      max-width: 140px;
      height: 28px;

      img {
        max-width: 100%;
        height: 28px;
        object-fit: contain;
      }
    }
  }

  .company-section {
    padding: 12px 16px;
  }

  .nav-section {
    flex: 1;
    overflow-y: auto;
    padding: 8px;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  background: #f5f5f5;
  border-radius: 10px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.2s;
  flex-shrink: 0;

  &:active {
    background: #e8e8e8;
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const CompanySelectContainer = styled.div`
  position: relative;

  .company-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(0, 0, 0, 0.45);
    z-index: 1;
    pointer-events: none;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const CompanySelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    border-style: dashed !important;
    height: 40px !important;
    display: flex;
    align-items: center;
    padding-left: 32px !important;
  }

  .ant-select-selection-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

type NavItemProps = {
  $isActive: boolean;
};

export const NavItem = styled.button<NavItemProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  margin: 4px 0;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.55);
  text-align: left;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.75);
  }

  svg {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: color-mix(in srgb, var(--primary) 10%, transparent);
      color: var(--primary);

      &:hover {
        background: color-mix(in srgb, var(--primary) 15%, transparent);
        color: var(--primary);
      }
    `}
`;

export const UserSection = styled.div`
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: auto;

  .user-info-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-light, rgba(24, 144, 255, 0.1));
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const UserName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CustomerName = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.2s;

  &:hover {
    border-color: var(--danger, #ff4d4f);
    color: var(--danger, #ff4d4f);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
